// extracted by mini-css-extract-plugin
export default {"dots":"oGLlox","dot-bounce":"QIBHRu","dotBounce":"QIBHRu"};